export enum ImprovementDriversTabID {
  Detail,
  Action,
  ImprovementIdea,
  Problem,
  Evidence,
  Comment,
}
